import { Message } from '../utils/Message';

export class ChangeEvent{
    public static CHANGE_EVENT: String = "changeEvent";
	newVal:String;
	msg:Message;
	
	public windowParams:any;

	constructor(type:String, m:Message) 
	{
		this.msg = m;
	}
}